@file:OptIn(InternalResourceApi::class)

package heyagenda.shared.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/heyagenda.shared.generated.resources/"

@delegate:ResourceContentHash(-528_429_471)
internal val Res.drawable.acorn: DrawableResource by lazy {
      DrawableResource("drawable:acorn", setOf(
        ResourceItem(setOf(), "${MD}drawable/acorn.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-342_629_149)
internal val Res.drawable.address_book: DrawableResource by lazy {
      DrawableResource("drawable:address_book", setOf(
        ResourceItem(setOf(), "${MD}drawable/address_book.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-508_485_494)
internal val Res.drawable.address_book_tabs: DrawableResource by lazy {
      DrawableResource("drawable:address_book_tabs", setOf(
        ResourceItem(setOf(), "${MD}drawable/address_book_tabs.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_014_034_840)
internal val Res.drawable.air_traffic_control: DrawableResource by lazy {
      DrawableResource("drawable:air_traffic_control", setOf(
        ResourceItem(setOf(), "${MD}drawable/air_traffic_control.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-998_160_454)
internal val Res.drawable.airplane: DrawableResource by lazy {
      DrawableResource("drawable:airplane", setOf(
        ResourceItem(setOf(), "${MD}drawable/airplane.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(758_481_963)
internal val Res.drawable.airplane_in_flight: DrawableResource by lazy {
      DrawableResource("drawable:airplane_in_flight", setOf(
        ResourceItem(setOf(), "${MD}drawable/airplane_in_flight.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_280_477_193)
internal val Res.drawable.airplane_landing: DrawableResource by lazy {
      DrawableResource("drawable:airplane_landing", setOf(
        ResourceItem(setOf(), "${MD}drawable/airplane_landing.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-665_378_562)
internal val Res.drawable.airplane_takeoff: DrawableResource by lazy {
      DrawableResource("drawable:airplane_takeoff", setOf(
        ResourceItem(setOf(), "${MD}drawable/airplane_takeoff.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(608_246_967)
internal val Res.drawable.airplane_taxiing: DrawableResource by lazy {
      DrawableResource("drawable:airplane_taxiing", setOf(
        ResourceItem(setOf(), "${MD}drawable/airplane_taxiing.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-470_656_247)
internal val Res.drawable.airplane_tilt: DrawableResource by lazy {
      DrawableResource("drawable:airplane_tilt", setOf(
        ResourceItem(setOf(), "${MD}drawable/airplane_tilt.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_044_037_458)
internal val Res.drawable.airplay: DrawableResource by lazy {
      DrawableResource("drawable:airplay", setOf(
        ResourceItem(setOf(), "${MD}drawable/airplay.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(490_709_703)
internal val Res.drawable.alarm: DrawableResource by lazy {
      DrawableResource("drawable:alarm", setOf(
        ResourceItem(setOf(), "${MD}drawable/alarm.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_877_261_673)
internal val Res.drawable.alien: DrawableResource by lazy {
      DrawableResource("drawable:alien", setOf(
        ResourceItem(setOf(), "${MD}drawable/alien.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_875_229_892)
internal val Res.drawable.align: DrawableResource by lazy {
      DrawableResource("drawable:align", setOf(
        ResourceItem(setOf(), "${MD}drawable/align.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-101_131_407)
internal val Res.drawable.align_bottom: DrawableResource by lazy {
      DrawableResource("drawable:align_bottom", setOf(
        ResourceItem(setOf(), "${MD}drawable/align_bottom.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_656_476_441)
internal val Res.drawable.align_bottom_simple: DrawableResource by lazy {
      DrawableResource("drawable:align_bottom_simple", setOf(
        ResourceItem(setOf(), "${MD}drawable/align_bottom_simple.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_916_520_130)
internal val Res.drawable.align_center_horizontal: DrawableResource by lazy {
      DrawableResource("drawable:align_center_horizontal", setOf(
        ResourceItem(setOf(), "${MD}drawable/align_center_horizontal.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_068_339_407)
internal val Res.drawable.align_center_horizontal_simple: DrawableResource by lazy {
      DrawableResource("drawable:align_center_horizontal_simple", setOf(
        ResourceItem(setOf(), "${MD}drawable/align_center_horizontal_simple.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-70_058_700)
internal val Res.drawable.align_center_vertical: DrawableResource by lazy {
      DrawableResource("drawable:align_center_vertical", setOf(
        ResourceItem(setOf(), "${MD}drawable/align_center_vertical.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(244_170_648)
internal val Res.drawable.align_center_vertical_simple: DrawableResource by lazy {
      DrawableResource("drawable:align_center_vertical_simple", setOf(
        ResourceItem(setOf(), "${MD}drawable/align_center_vertical_simple.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_035_691_307)
internal val Res.drawable.align_left: DrawableResource by lazy {
      DrawableResource("drawable:align_left", setOf(
        ResourceItem(setOf(), "${MD}drawable/align_left.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(596_161_258)
internal val Res.drawable.align_left_simple: DrawableResource by lazy {
      DrawableResource("drawable:align_left_simple", setOf(
        ResourceItem(setOf(), "${MD}drawable/align_left_simple.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_896_945_460)
internal val Res.drawable.align_right: DrawableResource by lazy {
      DrawableResource("drawable:align_right", setOf(
        ResourceItem(setOf(), "${MD}drawable/align_right.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-196_009_152)
internal val Res.drawable.align_right_simple: DrawableResource by lazy {
      DrawableResource("drawable:align_right_simple", setOf(
        ResourceItem(setOf(), "${MD}drawable/align_right_simple.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-128_511_938)
internal val Res.drawable.align_top_simple: DrawableResource by lazy {
      DrawableResource("drawable:align_top_simple", setOf(
        ResourceItem(setOf(), "${MD}drawable/align_top_simple.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_363_051_536)
internal val Res.drawable.amazon_logo: DrawableResource by lazy {
      DrawableResource("drawable:amazon_logo", setOf(
        ResourceItem(setOf(), "${MD}drawable/amazon_logo.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-423_446_687)
internal val Res.drawable.ambulance: DrawableResource by lazy {
      DrawableResource("drawable:ambulance", setOf(
        ResourceItem(setOf(), "${MD}drawable/ambulance.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_267_056_583)
internal val Res.drawable.anchor: DrawableResource by lazy {
      DrawableResource("drawable:anchor", setOf(
        ResourceItem(setOf(), "${MD}drawable/anchor.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(755_137_227)
internal val Res.drawable.anchor_simple: DrawableResource by lazy {
      DrawableResource("drawable:anchor_simple", setOf(
        ResourceItem(setOf(), "${MD}drawable/anchor_simple.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_692_706_302)
internal val Res.drawable.android_logo: DrawableResource by lazy {
      DrawableResource("drawable:android_logo", setOf(
        ResourceItem(setOf(), "${MD}drawable/android_logo.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(131_630_030)
internal val Res.drawable.angle: DrawableResource by lazy {
      DrawableResource("drawable:angle", setOf(
        ResourceItem(setOf(), "${MD}drawable/angle.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_650_418_051)
internal val Res.drawable.angular_logo: DrawableResource by lazy {
      DrawableResource("drawable:angular_logo", setOf(
        ResourceItem(setOf(), "${MD}drawable/angular_logo.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_588_202_132)
internal val Res.drawable.aperture: DrawableResource by lazy {
      DrawableResource("drawable:aperture", setOf(
        ResourceItem(setOf(), "${MD}drawable/aperture.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(629_933_857)
internal val Res.drawable.app_store_logo: DrawableResource by lazy {
      DrawableResource("drawable:app_store_logo", setOf(
        ResourceItem(setOf(), "${MD}drawable/app_store_logo.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_595_512_735)
internal val Res.drawable.app_window: DrawableResource by lazy {
      DrawableResource("drawable:app_window", setOf(
        ResourceItem(setOf(), "${MD}drawable/app_window.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-339_959_457)
internal val Res.drawable.apple_logo: DrawableResource by lazy {
      DrawableResource("drawable:apple_logo", setOf(
        ResourceItem(setOf(), "${MD}drawable/apple_logo.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-881_689_008)
internal val Res.drawable.apple_podcasts_logo: DrawableResource by lazy {
      DrawableResource("drawable:apple_podcasts_logo", setOf(
        ResourceItem(setOf(), "${MD}drawable/apple_podcasts_logo.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-113_776_570)
internal val Res.drawable.approximate_equals: DrawableResource by lazy {
      DrawableResource("drawable:approximate_equals", setOf(
        ResourceItem(setOf(), "${MD}drawable/approximate_equals.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-374_289_780)
internal val Res.drawable.archive: DrawableResource by lazy {
      DrawableResource("drawable:archive", setOf(
        ResourceItem(setOf(), "${MD}drawable/archive.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-174_961_795)
internal val Res.drawable.armchair: DrawableResource by lazy {
      DrawableResource("drawable:armchair", setOf(
        ResourceItem(setOf(), "${MD}drawable/armchair.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_162_534_277)
internal val Res.drawable.arrow: DrawableResource by lazy {
      DrawableResource("drawable:arrow", setOf(
        ResourceItem(setOf(), "${MD}drawable/arrow.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-562_258_896)
internal val Res.drawable.arrow_arc_left: DrawableResource by lazy {
      DrawableResource("drawable:arrow_arc_left", setOf(
        ResourceItem(setOf(), "${MD}drawable/arrow_arc_left.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_611_764_923)
internal val Res.drawable.arrow_arc_right: DrawableResource by lazy {
      DrawableResource("drawable:arrow_arc_right", setOf(
        ResourceItem(setOf(), "${MD}drawable/arrow_arc_right.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-914_467_670)
internal val Res.drawable.arrow_bend_double_up_left: DrawableResource by lazy {
      DrawableResource("drawable:arrow_bend_double_up_left", setOf(
        ResourceItem(setOf(), "${MD}drawable/arrow_bend_double_up_left.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_749_396_525)
internal val Res.drawable.arrow_bend_double_up_right: DrawableResource by lazy {
      DrawableResource("drawable:arrow_bend_double_up_right", setOf(
        ResourceItem(setOf(), "${MD}drawable/arrow_bend_double_up_right.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(947_133_983)
internal val Res.drawable.arrow_bend_down_left: DrawableResource by lazy {
      DrawableResource("drawable:arrow_bend_down_left", setOf(
        ResourceItem(setOf(), "${MD}drawable/arrow_bend_down_left.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(52_936_664)
internal val Res.drawable.arrow_bend_down_right: DrawableResource by lazy {
      DrawableResource("drawable:arrow_bend_down_right", setOf(
        ResourceItem(setOf(), "${MD}drawable/arrow_bend_down_right.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-514_363_409)
internal val Res.drawable.arrow_bend_left_down: DrawableResource by lazy {
      DrawableResource("drawable:arrow_bend_left_down", setOf(
        ResourceItem(setOf(), "${MD}drawable/arrow_bend_left_down.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(781_680_720)
internal val Res.drawable.arrow_bend_left_up: DrawableResource by lazy {
      DrawableResource("drawable:arrow_bend_left_up", setOf(
        ResourceItem(setOf(), "${MD}drawable/arrow_bend_left_up.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_055_785_247)
internal val Res.drawable.arrow_bend_right_down: DrawableResource by lazy {
      DrawableResource("drawable:arrow_bend_right_down", setOf(
        ResourceItem(setOf(), "${MD}drawable/arrow_bend_right_down.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-443_837_556)
internal val Res.drawable.arrow_bend_right_up: DrawableResource by lazy {
      DrawableResource("drawable:arrow_bend_right_up", setOf(
        ResourceItem(setOf(), "${MD}drawable/arrow_bend_right_up.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_310_424_765)
internal val Res.drawable.arrow_bend_up_left: DrawableResource by lazy {
      DrawableResource("drawable:arrow_bend_up_left", setOf(
        ResourceItem(setOf(), "${MD}drawable/arrow_bend_up_left.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(63_398_960)
internal val Res.drawable.arrow_bend_up_right: DrawableResource by lazy {
      DrawableResource("drawable:arrow_bend_up_right", setOf(
        ResourceItem(setOf(), "${MD}drawable/arrow_bend_up_right.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-929_437_141)
internal val Res.drawable.arrow_circle_down: DrawableResource by lazy {
      DrawableResource("drawable:arrow_circle_down", setOf(
        ResourceItem(setOf(), "${MD}drawable/arrow_circle_down.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_120_506_357)
internal val Res.drawable.arrow_circle_down_left: DrawableResource by lazy {
      DrawableResource("drawable:arrow_circle_down_left", setOf(
        ResourceItem(setOf(), "${MD}drawable/arrow_circle_down_left.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_147_471_708)
internal val Res.drawable.arrow_circle_down_right: DrawableResource by lazy {
      DrawableResource("drawable:arrow_circle_down_right", setOf(
        ResourceItem(setOf(), "${MD}drawable/arrow_circle_down_right.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-653_228_764)
internal val Res.drawable.arrow_circle_left: DrawableResource by lazy {
      DrawableResource("drawable:arrow_circle_left", setOf(
        ResourceItem(setOf(), "${MD}drawable/arrow_circle_left.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_473_607_415)
internal val Res.drawable.arrow_circle_right: DrawableResource by lazy {
      DrawableResource("drawable:arrow_circle_right", setOf(
        ResourceItem(setOf(), "${MD}drawable/arrow_circle_right.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(566_017_826)
internal val Res.drawable.arrow_circle_up: DrawableResource by lazy {
      DrawableResource("drawable:arrow_circle_up", setOf(
        ResourceItem(setOf(), "${MD}drawable/arrow_circle_up.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_035_491_547)
internal val Res.drawable.arrow_circle_up_left: DrawableResource by lazy {
      DrawableResource("drawable:arrow_circle_up_left", setOf(
        ResourceItem(setOf(), "${MD}drawable/arrow_circle_up_left.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_590_098_767)
internal val Res.drawable.arrow_circle_up_right: DrawableResource by lazy {
      DrawableResource("drawable:arrow_circle_up_right", setOf(
        ResourceItem(setOf(), "${MD}drawable/arrow_circle_up_right.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_098_491_134)
internal val Res.drawable.arrow_clockwise: DrawableResource by lazy {
      DrawableResource("drawable:arrow_clockwise", setOf(
        ResourceItem(setOf(), "${MD}drawable/arrow_clockwise.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_666_146_059)
internal val Res.drawable.arrow_counter_clockwise: DrawableResource by lazy {
      DrawableResource("drawable:arrow_counter_clockwise", setOf(
        ResourceItem(setOf(), "${MD}drawable/arrow_counter_clockwise.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_881_855_192)
internal val Res.drawable.arrow_down: DrawableResource by lazy {
      DrawableResource("drawable:arrow_down", setOf(
        ResourceItem(setOf(), "${MD}drawable/arrow_down.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(806_625_779)
internal val Res.drawable.arrow_down_left: DrawableResource by lazy {
      DrawableResource("drawable:arrow_down_left", setOf(
        ResourceItem(setOf(), "${MD}drawable/arrow_down_left.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(817_327)
internal val Res.drawable.arrow_down_right: DrawableResource by lazy {
      DrawableResource("drawable:arrow_down_right", setOf(
        ResourceItem(setOf(), "${MD}drawable/arrow_down_right.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(255_306_639)
internal val Res.drawable.arrow_elbow_down_left: DrawableResource by lazy {
      DrawableResource("drawable:arrow_elbow_down_left", setOf(
        ResourceItem(setOf(), "${MD}drawable/arrow_elbow_down_left.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_101_108_013)
internal val Res.drawable.arrow_elbow_down_right: DrawableResource by lazy {
      DrawableResource("drawable:arrow_elbow_down_right", setOf(
        ResourceItem(setOf(), "${MD}drawable/arrow_elbow_down_right.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_181_620_659)
internal val Res.drawable.arrow_elbow_left: DrawableResource by lazy {
      DrawableResource("drawable:arrow_elbow_left", setOf(
        ResourceItem(setOf(), "${MD}drawable/arrow_elbow_left.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_480_989_819)
internal val Res.drawable.arrow_elbow_left_down: DrawableResource by lazy {
      DrawableResource("drawable:arrow_elbow_left_down", setOf(
        ResourceItem(setOf(), "${MD}drawable/arrow_elbow_left_down.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_622_798_325)
internal val Res.drawable.arrow_elbow_left_up: DrawableResource by lazy {
      DrawableResource("drawable:arrow_elbow_left_up", setOf(
        ResourceItem(setOf(), "${MD}drawable/arrow_elbow_left_up.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_137_109_345)
internal val Res.drawable.arrow_elbow_up_left: DrawableResource by lazy {
      DrawableResource("drawable:arrow_elbow_up_left", setOf(
        ResourceItem(setOf(), "${MD}drawable/arrow_elbow_up_left.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-295_502_345)
internal val Res.drawable.arrow_elbow_up_right: DrawableResource by lazy {
      DrawableResource("drawable:arrow_elbow_up_right", setOf(
        ResourceItem(setOf(), "${MD}drawable/arrow_elbow_up_right.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(226_304_155)
internal val Res.drawable.arrow_fat_down: DrawableResource by lazy {
      DrawableResource("drawable:arrow_fat_down", setOf(
        ResourceItem(setOf(), "${MD}drawable/arrow_fat_down.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(178_577_119)
internal val Res.drawable.arrow_fat_left: DrawableResource by lazy {
      DrawableResource("drawable:arrow_fat_left", setOf(
        ResourceItem(setOf(), "${MD}drawable/arrow_fat_left.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(764_330_235)
internal val Res.drawable.arrow_fat_line_down: DrawableResource by lazy {
      DrawableResource("drawable:arrow_fat_line_down", setOf(
        ResourceItem(setOf(), "${MD}drawable/arrow_fat_line_down.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_372_724_288)
internal val Res.drawable.arrow_fat_line_left: DrawableResource by lazy {
      DrawableResource("drawable:arrow_fat_line_left", setOf(
        ResourceItem(setOf(), "${MD}drawable/arrow_fat_line_left.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(59_976_239)
internal val Res.drawable.arrow_fat_line_right: DrawableResource by lazy {
      DrawableResource("drawable:arrow_fat_line_right", setOf(
        ResourceItem(setOf(), "${MD}drawable/arrow_fat_line_right.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_999_670_040)
internal val Res.drawable.arrow_fat_line_up: DrawableResource by lazy {
      DrawableResource("drawable:arrow_fat_line_up", setOf(
        ResourceItem(setOf(), "${MD}drawable/arrow_fat_line_up.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_036_722_163)
internal val Res.drawable.arrow_fat_lines_down: DrawableResource by lazy {
      DrawableResource("drawable:arrow_fat_lines_down", setOf(
        ResourceItem(setOf(), "${MD}drawable/arrow_fat_lines_down.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(726_426_724)
internal val Res.drawable.arrow_fat_lines_left: DrawableResource by lazy {
      DrawableResource("drawable:arrow_fat_lines_left", setOf(
        ResourceItem(setOf(), "${MD}drawable/arrow_fat_lines_left.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-89_743_263)
internal val Res.drawable.arrow_fat_lines_right: DrawableResource by lazy {
      DrawableResource("drawable:arrow_fat_lines_right", setOf(
        ResourceItem(setOf(), "${MD}drawable/arrow_fat_lines_right.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_995_239_506)
internal val Res.drawable.arrow_fat_lines_up: DrawableResource by lazy {
      DrawableResource("drawable:arrow_fat_lines_up", setOf(
        ResourceItem(setOf(), "${MD}drawable/arrow_fat_lines_up.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-477_483_017)
internal val Res.drawable.arrow_fat_right: DrawableResource by lazy {
      DrawableResource("drawable:arrow_fat_right", setOf(
        ResourceItem(setOf(), "${MD}drawable/arrow_fat_right.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(628_290_179)
internal val Res.drawable.arrow_fat_up: DrawableResource by lazy {
      DrawableResource("drawable:arrow_fat_up", setOf(
        ResourceItem(setOf(), "${MD}drawable/arrow_fat_up.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_201_833_029)
internal val Res.drawable.arrow_left: DrawableResource by lazy {
      DrawableResource("drawable:arrow_left", setOf(
        ResourceItem(setOf(), "${MD}drawable/arrow_left.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(696_015_601)
internal val Res.drawable.arrow_line_down: DrawableResource by lazy {
      DrawableResource("drawable:arrow_line_down", setOf(
        ResourceItem(setOf(), "${MD}drawable/arrow_line_down.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(939_486_453)
internal val Res.drawable.arrow_line_left: DrawableResource by lazy {
      DrawableResource("drawable:arrow_line_left", setOf(
        ResourceItem(setOf(), "${MD}drawable/arrow_line_left.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_265_416_783)
internal val Res.drawable.arrow_line_right: DrawableResource by lazy {
      DrawableResource("drawable:arrow_line_right", setOf(
        ResourceItem(setOf(), "${MD}drawable/arrow_line_right.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-406_647_065)
internal val Res.drawable.arrow_line_up: DrawableResource by lazy {
      DrawableResource("drawable:arrow_line_up", setOf(
        ResourceItem(setOf(), "${MD}drawable/arrow_line_up.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_258_829_485)
internal val Res.drawable.arrow_line_up_left: DrawableResource by lazy {
      DrawableResource("drawable:arrow_line_up_left", setOf(
        ResourceItem(setOf(), "${MD}drawable/arrow_line_up_left.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_034_532_127)
internal val Res.drawable.arrow_line_up_right: DrawableResource by lazy {
      DrawableResource("drawable:arrow_line_up_right", setOf(
        ResourceItem(setOf(), "${MD}drawable/arrow_line_up_right.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_036_038_960)
internal val Res.drawable.arrow_right: DrawableResource by lazy {
      DrawableResource("drawable:arrow_right", setOf(
        ResourceItem(setOf(), "${MD}drawable/arrow_right.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_083_127_917)
internal val Res.drawable.arrow_square_down: DrawableResource by lazy {
      DrawableResource("drawable:arrow_square_down", setOf(
        ResourceItem(setOf(), "${MD}drawable/arrow_square_down.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_934_910_363)
internal val Res.drawable.arrow_square_down_left: DrawableResource by lazy {
      DrawableResource("drawable:arrow_square_down_left", setOf(
        ResourceItem(setOf(), "${MD}drawable/arrow_square_down_left.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_225_950_499)
internal val Res.drawable.arrow_square_down_right: DrawableResource by lazy {
      DrawableResource("drawable:arrow_square_down_right", setOf(
        ResourceItem(setOf(), "${MD}drawable/arrow_square_down_right.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_337_476_233)
internal val Res.drawable.arrow_square_in: DrawableResource by lazy {
      DrawableResource("drawable:arrow_square_in", setOf(
        ResourceItem(setOf(), "${MD}drawable/arrow_square_in.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_494_796_317)
internal val Res.drawable.arrow_square_left: DrawableResource by lazy {
      DrawableResource("drawable:arrow_square_left", setOf(
        ResourceItem(setOf(), "${MD}drawable/arrow_square_left.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(762_394_497)
internal val Res.drawable.arrow_square_out: DrawableResource by lazy {
      DrawableResource("drawable:arrow_square_out", setOf(
        ResourceItem(setOf(), "${MD}drawable/arrow_square_out.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_979_792_328)
internal val Res.drawable.arrow_square_right: DrawableResource by lazy {
      DrawableResource("drawable:arrow_square_right", setOf(
        ResourceItem(setOf(), "${MD}drawable/arrow_square_right.xml", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("acorn", Res.drawable.acorn)
  map.put("address_book", Res.drawable.address_book)
  map.put("address_book_tabs", Res.drawable.address_book_tabs)
  map.put("air_traffic_control", Res.drawable.air_traffic_control)
  map.put("airplane", Res.drawable.airplane)
  map.put("airplane_in_flight", Res.drawable.airplane_in_flight)
  map.put("airplane_landing", Res.drawable.airplane_landing)
  map.put("airplane_takeoff", Res.drawable.airplane_takeoff)
  map.put("airplane_taxiing", Res.drawable.airplane_taxiing)
  map.put("airplane_tilt", Res.drawable.airplane_tilt)
  map.put("airplay", Res.drawable.airplay)
  map.put("alarm", Res.drawable.alarm)
  map.put("alien", Res.drawable.alien)
  map.put("align", Res.drawable.align)
  map.put("align_bottom", Res.drawable.align_bottom)
  map.put("align_bottom_simple", Res.drawable.align_bottom_simple)
  map.put("align_center_horizontal", Res.drawable.align_center_horizontal)
  map.put("align_center_horizontal_simple", Res.drawable.align_center_horizontal_simple)
  map.put("align_center_vertical", Res.drawable.align_center_vertical)
  map.put("align_center_vertical_simple", Res.drawable.align_center_vertical_simple)
  map.put("align_left", Res.drawable.align_left)
  map.put("align_left_simple", Res.drawable.align_left_simple)
  map.put("align_right", Res.drawable.align_right)
  map.put("align_right_simple", Res.drawable.align_right_simple)
  map.put("align_top_simple", Res.drawable.align_top_simple)
  map.put("amazon_logo", Res.drawable.amazon_logo)
  map.put("ambulance", Res.drawable.ambulance)
  map.put("anchor", Res.drawable.anchor)
  map.put("anchor_simple", Res.drawable.anchor_simple)
  map.put("android_logo", Res.drawable.android_logo)
  map.put("angle", Res.drawable.angle)
  map.put("angular_logo", Res.drawable.angular_logo)
  map.put("aperture", Res.drawable.aperture)
  map.put("app_store_logo", Res.drawable.app_store_logo)
  map.put("app_window", Res.drawable.app_window)
  map.put("apple_logo", Res.drawable.apple_logo)
  map.put("apple_podcasts_logo", Res.drawable.apple_podcasts_logo)
  map.put("approximate_equals", Res.drawable.approximate_equals)
  map.put("archive", Res.drawable.archive)
  map.put("armchair", Res.drawable.armchair)
  map.put("arrow", Res.drawable.arrow)
  map.put("arrow_arc_left", Res.drawable.arrow_arc_left)
  map.put("arrow_arc_right", Res.drawable.arrow_arc_right)
  map.put("arrow_bend_double_up_left", Res.drawable.arrow_bend_double_up_left)
  map.put("arrow_bend_double_up_right", Res.drawable.arrow_bend_double_up_right)
  map.put("arrow_bend_down_left", Res.drawable.arrow_bend_down_left)
  map.put("arrow_bend_down_right", Res.drawable.arrow_bend_down_right)
  map.put("arrow_bend_left_down", Res.drawable.arrow_bend_left_down)
  map.put("arrow_bend_left_up", Res.drawable.arrow_bend_left_up)
  map.put("arrow_bend_right_down", Res.drawable.arrow_bend_right_down)
  map.put("arrow_bend_right_up", Res.drawable.arrow_bend_right_up)
  map.put("arrow_bend_up_left", Res.drawable.arrow_bend_up_left)
  map.put("arrow_bend_up_right", Res.drawable.arrow_bend_up_right)
  map.put("arrow_circle_down", Res.drawable.arrow_circle_down)
  map.put("arrow_circle_down_left", Res.drawable.arrow_circle_down_left)
  map.put("arrow_circle_down_right", Res.drawable.arrow_circle_down_right)
  map.put("arrow_circle_left", Res.drawable.arrow_circle_left)
  map.put("arrow_circle_right", Res.drawable.arrow_circle_right)
  map.put("arrow_circle_up", Res.drawable.arrow_circle_up)
  map.put("arrow_circle_up_left", Res.drawable.arrow_circle_up_left)
  map.put("arrow_circle_up_right", Res.drawable.arrow_circle_up_right)
  map.put("arrow_clockwise", Res.drawable.arrow_clockwise)
  map.put("arrow_counter_clockwise", Res.drawable.arrow_counter_clockwise)
  map.put("arrow_down", Res.drawable.arrow_down)
  map.put("arrow_down_left", Res.drawable.arrow_down_left)
  map.put("arrow_down_right", Res.drawable.arrow_down_right)
  map.put("arrow_elbow_down_left", Res.drawable.arrow_elbow_down_left)
  map.put("arrow_elbow_down_right", Res.drawable.arrow_elbow_down_right)
  map.put("arrow_elbow_left", Res.drawable.arrow_elbow_left)
  map.put("arrow_elbow_left_down", Res.drawable.arrow_elbow_left_down)
  map.put("arrow_elbow_left_up", Res.drawable.arrow_elbow_left_up)
  map.put("arrow_elbow_up_left", Res.drawable.arrow_elbow_up_left)
  map.put("arrow_elbow_up_right", Res.drawable.arrow_elbow_up_right)
  map.put("arrow_fat_down", Res.drawable.arrow_fat_down)
  map.put("arrow_fat_left", Res.drawable.arrow_fat_left)
  map.put("arrow_fat_line_down", Res.drawable.arrow_fat_line_down)
  map.put("arrow_fat_line_left", Res.drawable.arrow_fat_line_left)
  map.put("arrow_fat_line_right", Res.drawable.arrow_fat_line_right)
  map.put("arrow_fat_line_up", Res.drawable.arrow_fat_line_up)
  map.put("arrow_fat_lines_down", Res.drawable.arrow_fat_lines_down)
  map.put("arrow_fat_lines_left", Res.drawable.arrow_fat_lines_left)
  map.put("arrow_fat_lines_right", Res.drawable.arrow_fat_lines_right)
  map.put("arrow_fat_lines_up", Res.drawable.arrow_fat_lines_up)
  map.put("arrow_fat_right", Res.drawable.arrow_fat_right)
  map.put("arrow_fat_up", Res.drawable.arrow_fat_up)
  map.put("arrow_left", Res.drawable.arrow_left)
  map.put("arrow_line_down", Res.drawable.arrow_line_down)
  map.put("arrow_line_left", Res.drawable.arrow_line_left)
  map.put("arrow_line_right", Res.drawable.arrow_line_right)
  map.put("arrow_line_up", Res.drawable.arrow_line_up)
  map.put("arrow_line_up_left", Res.drawable.arrow_line_up_left)
  map.put("arrow_line_up_right", Res.drawable.arrow_line_up_right)
  map.put("arrow_right", Res.drawable.arrow_right)
  map.put("arrow_square_down", Res.drawable.arrow_square_down)
  map.put("arrow_square_down_left", Res.drawable.arrow_square_down_left)
  map.put("arrow_square_down_right", Res.drawable.arrow_square_down_right)
  map.put("arrow_square_in", Res.drawable.arrow_square_in)
  map.put("arrow_square_left", Res.drawable.arrow_square_left)
  map.put("arrow_square_out", Res.drawable.arrow_square_out)
  map.put("arrow_square_right", Res.drawable.arrow_square_right)
}
